module.exports = __webpack_public_path__ + "img/senior-designer-icon.6054a200.svg";